export const primaryColor = 'violet';
